import { useState } from 'react';

const useCarousel = (itemCount) => {
  const [currentPosition, setCurrentPosition] = useState(0);

  const nextItem = () => {
    if (currentPosition === itemCount - 1) {
      setCurrentPosition(0);
    } else {
      setCurrentPosition(currentPosition + 1);
    }
  };

  const previousItem = () => {
    if (currentPosition === 0) {
      setCurrentPosition(itemCount - 1);
    } else {
      setCurrentPosition(currentPosition - 1);
    }
  };

  return {
    prevHandler: previousItem,
    nextHandler: nextItem,
    currentPosition,
  };
};

export default useCarousel;
